<template lang="pug">
  table
    thead
      tr
        th(v-for="name in Object.keys(value[0]) ") {{getValueName(name)}}
    tbody
      tr(v-for="item in value")
        td(v-for="text in Object.values(item) ") {{text||0}}
</template>

<script>
import { REGION_CONFIG } from '@/config/regions'

export default {
  name: 'map-popup-table',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getValueName(item) {
      return REGION_CONFIG.texts[item]
    },
  },
}
</script>

<style scoped lang="scss">
table {
  border: 1px solid;
  margin-bottom: 5px;
  margin-top: 5px;

  td,
  th {
    border: 1px solid;
    text-align: left;
    padding: 2px;
  }
}
</style>
